import React from 'react'
import Footer from '../components/footerComponent/footer'
import EditLesson from '../components/teacherComponent/editLessonComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function EditLessonPage() {
    return (
        <Layout>
            <Header/>
            <EditLesson/>
            <Footer/>
        </Layout>
    );
};